import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
  getCountriesList,
  getAllGender,
  uploadMedia,
} from '../../../../../../API/api-endpoint'
import {KTIcon} from '../../../../../../_metronic/helpers'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import Select from 'react-select'
import {getImageBaseUrl} from '../../../../../../utils/Utils'
import {Modal, Button, Table, Form} from 'react-bootstrap'
import clsx from 'clsx'

const LeaderboardVideoPlayPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [enableLeaderboard, setEnableLeaderboard] = useState(false)
  const [videoConfigs, setVideoConfigs] = useState<any[]>([])
  const [packageMedia, setPackageMedia] = useState<any>({
    mediaType: 'image',
    mediaUrl: '',
    videoLink: '',
    isSkippable: false,
    status: true,
  })
  const [maleHelpContent, setMaleHelpContent] = useState('')
  const [femaleHelpContent, setFemaleHelpContent] = useState('')
  const [maleRewardRules, setMaleRewardRules] = useState<any[]>([])
  const [femaleRewardRules, setFemaleRewardRules] = useState<any[]>([])
  const [rewardModal, setRewardModal] = useState(false)
  const [modalGender, setModalGender] = useState<'male' | 'female'>('male')
  const [currentReward, setCurrentReward] = useState<any>({
    rank: 1,
    reward: 0,
  })
  const [countries, setCountries] = useState<any[]>([])
  const [_genders, setGenders] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [isEditingReward, setIsEditingReward] = useState(false)

  // State for adding/editing a row
  const [showModal, setShowModal] = useState(false)
  const [currentRow, setCurrentRow] = useState<any>({
    screenName: 'Video Call Screen',
    gender: 'Both',
    countries: [],
    videoUrl: '',
    videoLink: '',
    isSkippable: false,
  })
  const [editingIndex, setEditingIndex] = useState<number | null>(null)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    // Fetch countries
    const countryRes = await getCountriesList()
    if (countryRes) {
      setCountries(countryRes.map((c: any) => ({value: c.name, label: c.name})))
    }

    // Fetch genders
    const genderRes = await getAllGender()
    if (genderRes.success) {
      setGenders(genderRes.data)
    }

    // Fetch configuration
    const configRes = await getConfigurationByName('leaderboard_video_play')
    if (configRes.success) {
      setConfigId(configRes.data.id)
      const parsed = JSON.parse(configRes.data.values)
      setEnableLeaderboard(parsed.enableLeaderboard || false)
      setVideoConfigs(parsed.list || [])
      setPackageMedia(
        parsed.packageMedia || {
          mediaType: 'image',
          mediaUrl: '',
          videoLink: '',
          isSkippable: false,
        }
      )
      setMaleHelpContent(parsed.maleHelpContent || parsed.helpContent || '')
      setFemaleHelpContent(parsed.femaleHelpContent || parsed.helpContent || '')
      setMaleRewardRules(parsed.maleRewardRules || [])
      setFemaleRewardRules(parsed.femaleRewardRules || [])
    }
  }

  const handleSaveConfig = async (newConfig?: any) => {
    const dataToSave = newConfig || {
      enableLeaderboard,
      list: videoConfigs,
      packageMedia,
      maleHelpContent,
      femaleHelpContent,
      maleRewardRules,
      femaleRewardRules,
    }

    setLoading(true)
    const result = await updateConfigurationByConfigID(configID, dataToSave, null)
    setLoading(false)

    if (result.success) {
      ToastUtils({type: 'success', message: 'Configuration saved successfully'})
    } else {
      ErrorToastUtils()
    }
  }

  const handleToggleLeaderboard = (checked: boolean) => {
    setEnableLeaderboard(checked)
    handleSaveConfig({
      enableLeaderboard: checked,
      list: videoConfigs,
      packageMedia,
      maleHelpContent,
      femaleHelpContent,
    })
  }

  const openAddModal = () => {
    setCurrentRow({
      screenName: 'Video Call Screen',
      gender: 'Both',
      countries: [],
      videoLink: '',
      isSkippable: false,
      status: true,
    })
    setEditingIndex(null)
    setShowModal(true)
  }

  const openEditModal = (index: number) => {
    setCurrentRow({...videoConfigs[index]})
    setEditingIndex(index)
    setShowModal(true)
  }

  const saveRow = () => {
    // Duplicate Validation (including overlap check for 'Both')
    const duplicate = videoConfigs.find((config: any, idx: number) => {
      if (editingIndex !== null && idx === editingIndex) return false
      if (config.screenName !== currentRow.screenName) return false

      // Check for exact match or 'Both' conflict
      return (
        config.gender === currentRow.gender ||
        currentRow.gender === 'Both' ||
        config.gender === 'Both'
      )
    })

    if (duplicate) {
      ToastUtils({
        type: 'error',
        message: `Conflict: A rule for "${currentRow.screenName}" already covers this gender configuration.`,
      })
      return
    }

    let newList = [...videoConfigs]
    if (editingIndex !== null) {
      newList[editingIndex] = currentRow
    } else {
      newList.push(currentRow)
    }
    setVideoConfigs(newList)
    setShowModal(false)
  }

  const deleteRow = (index: number) => {
    const newList = videoConfigs.filter((_, i) => i !== index)
    setVideoConfigs(newList)
  }



  const renderMediaPreview = (url: string, size: string = '50px') => {
    if (!url) return <span className='text-muted fs-8'>No Media</span>
    const fullUrl = url.startsWith('http') ? url : `${getImageBaseUrl()}/${url}`
    const ext = '.' + url.split('.').pop()?.toLowerCase()
    
    const isImg = ['.gif', '.jpg', '.jpeg', '.png', '.webp'].includes(ext)
    const isVid = ['.mpg', '.mp2', '.mpeg', '.mpe', '.mpv', '.mp4', '.mov'].includes(ext)

    if (isImg) {
      return (
        <img
          src={fullUrl}
          alt='preview'
          style={{width: size, height: size, objectFit: 'cover', borderRadius: '4px'}}
        />
      )
    }

    if (isVid) {
      return (
        <video
          src={fullUrl}
          style={{width: size, height: size, objectFit: 'cover', borderRadius: '4px'}}
          muted
          autoPlay
          loop
          playsInline
        />
      )
    }

    return <i className='ki-duotone ki-file fs-2'></i>
  }

  const handleFileUpload = async (event: any, target: 'row' | 'package') => {
    const file = event.target.files[0]
    if (!file) return

    setLoading(true)
    const result = await uploadMedia(file)
    setLoading(false)

    if (result.success) {
      const path = result.data.path
      if (target === 'row') {
        setCurrentRow({...currentRow, videoLink: path})
      } else {
        setPackageMedia({...packageMedia, mediaUrl: path})
      }
      ToastUtils({type: 'success', message: 'File uploaded successfully'})
    } else {
      ErrorToastUtils()
    }
  }


  return (
    <div className='row g-5 g-xl-10'>
      {/* General Toggle */}
      <div className='col-12'>
        <div className='card card-flush h-md-100'>
          <div className='card-header pt-7'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-gray-800'>General Settings</span>
            </h3>
          </div>
          <div className='card-body pt-5'>
            <div className='d-flex align-items-center justify-content-between bg-light p-4 rounded'>
              <div>
                <h4 className='fw-bold mb-1'>Enable Leaderboard</h4>
                <p className='text-muted fs-7 mb-0'>Enable or disable the leaderboard feature site-wide.</p>
              </div>
              <div className='form-check form-switch'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  checked={enableLeaderboard}
                  onChange={(e) => handleToggleLeaderboard(e.target.checked)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Playback List */}
      <div className='col-12'>
        <div className='card card-flush'>
          <div className='card-header pt-7'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-gray-800'>Video Playback Rules</span>
              <span className='text-gray-400 mt-1 fw-semibold fs-6'>
                Configure videos based on screen, gender, and country.
              </span>
            </h3>
            <div className='card-toolbar'>
              <button className='btn btn-sm btn-light-primary' onClick={openAddModal}>
                <i className='ki-duotone ki-plus fs-2'></i> Add Rule
              </button>
            </div>
          </div>
          <div className='card-body pt-5'>
            <div className='table-responsive'>
              <Table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='ps-4 min-w-150px rounded-start'>Screen</th>
                    <th className='min-w-100px text-center'>Preview</th>
                    <th className='min-w-100px'>Gender</th>
                    <th className='min-w-150px'>Countries</th>
                    <th className='min-w-100px text-center'>Status</th>
                    <th className='min-w-120px'>Skippable</th>
                    <th className='min-w-150px'>Media</th>
                    <th className='min-w-100px text-end rounded-end'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {videoConfigs.map((item, index) => (
                    <tr key={index}>
                      <td className='ps-4'>
                        <span className='text-gray-800 fw-bold d-block fs-6'>{item.screenName}</span>
                      </td>
                      <td className='text-center'>
                        {renderMediaPreview(item.videoLink)}
                      </td>
                      <td>
                        <span className='badge badge-light-primary fw-bold'>{item.gender}</span>
                      </td>
                      <td>
                        <div className='d-flex flex-wrap gap-1'>
                          {item.countries.length > 5 ? (
                            <span className='badge badge-light-info'>{item.countries.length} Countries</span>
                          ) : (
                            item.countries.map((c: any, i: number) => (
                              <span key={i} className='badge badge-light-info'>
                                {c}
                              </span>
                            ))
                          )}
                        </div>
                      </td>
                      <td className='text-center'>
                        <div className='form-check form-switch d-flex justify-content-center'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            role='switch'
                            checked={item.status !== false}
                            onChange={(e) => {
                                const updated = [...videoConfigs];
                                updated[index] = { ...item, status: e.target.checked };
                                setVideoConfigs(updated);
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        <span
                          className={clsx(
                            'badge fw-bold',
                            item.isSkippable ? 'badge-light-success' : 'badge-light-danger'
                          )}
                        >
                          {item.isSkippable ? 'Yes' : 'No'}
                        </span>
                      </td>
                      <td>
                        {item.videoLink ? (
                          <a
                            href={
                              item.videoLink.startsWith('http')
                                ? item.videoLink
                                : `${getImageBaseUrl()}/${item.videoLink}`
                            }
                            target='_blank'
                            rel='noreferrer'
                            className='text-primary fs-7'
                          >
                            View Link
                          </a>
                        ) : (
                          <span className='text-muted fs-7'>No Link</span>
                        )}
                      </td>
                      <td className='text-end'>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          onClick={() => openEditModal(index)}
                        >
                          <i className='ki-duotone ki-pencil fs-2'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                          </i>
                        </button>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                          onClick={() => deleteRow(index)}
                        >
                          <i className='ki-duotone ki-trash fs-2'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                            <span className='path4'></span>
                            <span className='path5'></span>
                          </i>
                        </button>
                      </td>
                    </tr>
                  ))}
                  {videoConfigs.length === 0 && (
                    <tr>
                      <td colSpan={5} className='text-center text-muted py-10'>
                        No rules configured yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            <div className='d-flex justify-content-end align-items-center mt-4'>
              <span className='text-danger fs-7 fw-bold me-3'>* It is compulsory to click this button; otherwise, the data will not be saved.</span>
              <button className='btn btn-primary' onClick={() => handleSaveConfig()}>
                Save Rules
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Package Media Configuration */}
      <div className='col-lg-12'>
        <div className='card card-flush h-md-100'>
          <div className='card-header pt-7'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-gray-800'>Package Screen Media</span>
              <span className='text-gray-400 mt-1 fw-semibold fs-6'>
                Global media configuration for the package screen.
              </span>
            </h3>
          </div>
          <div className='card-body pt-5'>
            <div className='mb-7'>
              <label className='form-label fw-bold'>Media Type</label>
              <div className='d-flex gap-5 mt-2'>
                <label className='form-check form-check-custom form-check-solid'>
                  <input
                    className='form-check-input'
                    type='radio'
                    name='pkgMediaType'
                    value='image'
                    checked={packageMedia.mediaType === 'image'}
                    onChange={() => setPackageMedia({...packageMedia, mediaType: 'image'})}
                  />
                  <span className='form-check-label'>Image</span>
                </label>
                <label className='form-check form-check-custom form-check-solid'>
                  <input
                    className='form-check-input'
                    type='radio'
                    name='pkgMediaType'
                    value='video'
                    checked={packageMedia.mediaType === 'video'}
                    onChange={() => setPackageMedia({...packageMedia, mediaType: 'video'})}
                  />
                  <span className='form-check-label'>Video</span>
                </label>
              </div>
            </div>

            <div className='mb-7'>
              <label className='form-label fw-bold'>Media Content</label>
              <div className='card bg-light border p-5'>
                <div className='mb-5'>
                  <label className='fs-7 fw-bold mb-2 d-block'>1. Upload File (Image/Video)</label>
                  <input
                    type='file'
                    className='form-control form-control-solid'
                    onChange={(e) => handleFileUpload(e, 'package')}
                    accept={packageMedia.mediaType === 'image' ? 'image/*' : 'video/*'}
                  />
                </div>

                <div className='separator separator-dashed mb-5'></div>

                <div>
                  <label className='fs-7 fw-bold mb-2 d-block'>2. Media Link (uploaded or external)</label>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    placeholder='Enter media URL...'
                    value={packageMedia.mediaUrl || ''}
                    onChange={(e) => setPackageMedia({...packageMedia, mediaUrl: e.target.value})}
                  />
                  {packageMedia.mediaUrl && !packageMedia.mediaUrl.startsWith('http') && (
                    <div className='mt-2'>
                        <span className='text-primary fs-8 fw-bold'>Relative Path Detected: </span>
                        <span className='text-muted fs-8'>{packageMedia.mediaUrl}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {packageMedia.mediaUrl && (
              <div className='mb-7'>
                <label className='form-label fw-bold d-block mb-3'>Media Preview</label>
                <div className='border rounded p-4 text-center bg-light'>
                  {renderMediaPreview(packageMedia.mediaUrl, '100%')}
                  <div className='mt-3'>
                    <a
                      href={
                        packageMedia.mediaUrl.startsWith('http')
                          ? packageMedia.mediaUrl
                          : `${getImageBaseUrl()}/${packageMedia.mediaUrl}`
                      }
                      target='_blank'
                      rel='noreferrer'
                      className='btn btn-sm btn-light-primary w-100'
                    >
                      <i className='ki-duotone ki-eye fs-3'></i> View Full Media
                    </a>
                  </div>
                </div>
              </div>
            )}

            <div className='mb-7'>
              <div className='d-flex align-items-center justify-content-between bg-light p-4 rounded'>
                <div>
                  <label className='form-label fw-bold mb-0'>Status</label>
                  <div className='fs-7 text-muted'>Enable or disable package screen media</div>
                </div>
                <div className='form-check form-switch'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    role='switch'
                    checked={packageMedia.status !== false}
                    onChange={(e) => setPackageMedia({...packageMedia, status: e.target.checked})}
                  />
                </div>
              </div>
            </div>

            <div className='mb-7'>
              <label className='form-label fw-bold'>Is Skippable</label>
              <div className='form-check form-switch mt-2'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  role='switch'
                  checked={packageMedia.isSkippable}
                  onChange={(e) => setPackageMedia({...packageMedia, isSkippable: e.target.checked})}
                />
              </div>
            </div>

            <div className='d-flex justify-content-end align-items-center'>
              <span className='text-danger fs-7 fw-bold me-3'>* It is compulsory to click this button; otherwise, the data will not be saved.</span>
              <button className='btn btn-primary' onClick={() => handleSaveConfig()} disabled={loading}>
                {loading ? 'Saving...' : 'Save Package Media'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Help Content */}
      <div className='col-12'>
        <div className='card card-flush'>
          <div className='card-header pt-7'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-gray-800'>Help Content (HTML)</span>
              <span className='text-gray-400 mt-1 fw-semibold fs-6'>
                Configure the dynamic help content for users (separate for Male and Female).
              </span>
            </h3>
          </div>
          <div className='card-body pt-5'>
            <div className='row'>
              <div className='col-lg-6 mb-7'>
                <label className='form-label fw-bold text-primary mb-3'>Male Help Content</label>
                <div style={{height: '300px', marginBottom: '50px'}}>
                  <ReactQuill 
                    theme='snow' 
                    value={maleHelpContent} 
                    onChange={setMaleHelpContent} 
                    style={{height: '100%'}} 
                  />
                </div>
              </div>
              <div className='col-lg-6 mb-7'>
                <label className='form-label fw-bold text-danger mb-3'>Female Help Content</label>
                <div style={{height: '300px', marginBottom: '50px'}}>
                  <ReactQuill 
                    theme='snow' 
                    value={femaleHelpContent} 
                    onChange={setFemaleHelpContent} 
                    style={{height: '100%'}} 
                  />
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-end align-items-center mt-5'>
              <span className='text-danger fs-7 fw-bold me-3'>* It is compulsory to click this button; otherwise, the data will not be saved.</span>
              <button className='btn btn-primary' onClick={() => handleSaveConfig()} disabled={loading}>
                {loading ? 'Saving...' : 'Save Help Content'}
              </button>
            </div>
          </div>
        </div>
      </div>


      {/* Reward Rules Section */}
      <div className='col-12'>
        <div className='card card-flush'>
          <div className='card-header pt-7'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-gray-800'>Leaderboard Reward Rules</span>
              <span className='text-gray-400 mt-1 fw-semibold fs-6'>
                Configure credits (Male) and diamonds (Female) rewards based on separate weekly ranks.
              </span>
            </h3>
          </div>
          <div className='card-body pt-5'>
            <div className='row'>
              {/* Male Rules */}
              <div className='col-lg-6'>
                <div className='border rounded p-5 bg-light mb-7'>
                  <div className='d-flex justify-content-between align-items-center mb-5'>
                    <h4 className='fw-bold text-primary mb-0'>Male Reward Rules (Credits)</h4>
                    <button
                      className='btn btn-sm btn-light-primary'
                      onClick={() => {
                        setModalGender('male')
                        setIsEditingReward(false)
                        setCurrentReward({rank: maleRewardRules.length + 1, reward: 0})
                        setRewardModal(true)
                      }}
                    >
                      <KTIcon iconName='plus' className='fs-3' /> Add Male Rule
                    </button>
                  </div>
                  <div className='table-responsive'>
                    <Table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold text-muted bg-white'>
                          <th className='ps-4 rounded-start'>Rank</th>
                          <th className=''>Reward</th>
                          <th className='text-end rounded-end text-end px-4'>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {maleRewardRules
                          .sort((a, b) => a.rank - b.rank)
                          .map((rule, index) => (
                            <tr key={index}>
                              <td className='ps-4'>
                                <span className='badge badge-light-primary fw-bold'>#{rule.rank}</span>
                              </td>
                              <td>
                                <span className='text-gray-800 fw-bold'>{rule.reward} Credits</span>
                              </td>
                              <td className='text-end px-4'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  onClick={() => {
                                    setModalGender('male')
                                    setIsEditingReward(true)
                                    setCurrentReward(rule)
                                    setRewardModal(true)
                                  }}
                                >
                                  <KTIcon iconName='pencil' className='fs-3' />
                                </button>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                  onClick={() => {
                                    setMaleRewardRules(maleRewardRules.filter((_, i) => i !== index))
                                  }}
                                >
                                  <KTIcon iconName='trash' className='fs-3' />
                                </button>
                              </td>
                            </tr>
                          ))}
                        {maleRewardRules.length === 0 && (
                          <tr>
                            <td colSpan={3} className='text-center text-muted'>
                              No male rules configured.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>

              {/* Female Rules */}
              <div className='col-lg-6'>
                <div className='border rounded p-5 bg-light mb-7'>
                  <div className='d-flex justify-content-between align-items-center mb-5'>
                    <h4 className='fw-bold text-danger mb-0'>Female Reward Rules (Diamonds)</h4>
                    <button
                      className='btn btn-sm btn-light-danger'
                      onClick={() => {
                        setModalGender('female')
                        setIsEditingReward(false)
                        setCurrentReward({rank: femaleRewardRules.length + 1, reward: 0})
                        setRewardModal(true)
                      }}
                    >
                      <KTIcon iconName='plus' className='fs-3' /> Add Female Rule
                    </button>
                  </div>
                  <div className='table-responsive'>
                    <Table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold text-muted bg-white'>
                          <th className='ps-4 rounded-start'>Rank</th>
                          <th className=''>Reward</th>
                          <th className='text-end rounded-end text-end px-4'>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {femaleRewardRules
                          .sort((a, b) => a.rank - b.rank)
                          .map((rule, index) => (
                            <tr key={index}>
                              <td className='ps-4'>
                                <span className='badge badge-light-danger fw-bold'>#{rule.rank}</span>
                              </td>
                              <td>
                                <span className='text-gray-800 fw-bold'>{rule.reward} Diamonds</span>
                              </td>
                              <td className='text-end px-4'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  onClick={() => {
                                    setModalGender('female')
                                    setIsEditingReward(true)
                                    setCurrentReward(rule)
                                    setRewardModal(true)
                                  }}
                                >
                                  <KTIcon iconName='pencil' className='fs-3' />
                                </button>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                  onClick={() => {
                                    setFemaleRewardRules(femaleRewardRules.filter((_, i) => i !== index))
                                  }}
                                >
                                  <KTIcon iconName='trash' className='fs-3' />
                                </button>
                              </td>
                            </tr>
                          ))}
                        {femaleRewardRules.length === 0 && (
                          <tr>
                            <td colSpan={3} className='text-center text-muted'>
                              No female rules configured.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>

            <div className='d-flex justify-content-end align-items-center mt-4'>
              <span className='text-danger fs-7 fw-bold me-3'>* It is compulsory to click this button; otherwise, the data will not be saved.</span>
              <button
                className='btn btn-primary'
                onClick={() => handleSaveConfig()}
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Save Reward Rules'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Reward Modal */}
      <Modal show={rewardModal} onHide={() => setRewardModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Configure {modalGender === 'male' ? 'Male' : 'Female'} Reward</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className='mb-7'>
              <label className='form-label fw-bold'>Rank</label>
              <input
                type='number'
                className='form-control form-control-solid'
                value={currentReward.rank}
                onChange={(e) => setCurrentReward({...currentReward, rank: parseInt(e.target.value)})}
                disabled={isEditingReward}
              />
            </div>
            <div className='mb-7'>
              <label className='form-label fw-bold'>
                Reward {modalGender === 'male' ? '(Credits)' : '(Diamonds)'}
              </label>
              <input
                type='number'
                className='form-control form-control-solid'
                value={currentReward.reward}
                onChange={(e) =>
                  setCurrentReward({...currentReward, reward: parseInt(e.target.value)})
                }
              />
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setRewardModal(false)}>
            Close
          </Button>
          <Button
            variant='primary'
            onClick={() => {
              const ruleList = modalGender === 'male' ? maleRewardRules : femaleRewardRules
              const setRuleList = modalGender === 'male' ? setMaleRewardRules : setFemaleRewardRules

              const existingIndex = ruleList.findIndex((r: any) => r.rank === currentReward.rank)
              let newList = [...ruleList]
              if (existingIndex > -1) {
                newList[existingIndex] = currentReward
              } else {
                newList.push(currentReward)
              }
              setRuleList(newList)
              setRewardModal(false)
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add/Edit Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{editingIndex !== null ? 'Edit Rule' : 'Add New Rule'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className='row'>
              <div className='col-md-6 mb-7'>
                <label className='form-label fw-bold'>Screen Name</label>
                <select
                  className='form-select form-select-solid'
                  value={currentRow.screenName}
                  onChange={(e) => setCurrentRow({...currentRow, screenName: e.target.value})}
                >
                  <option value='Video Call Screen'>Video Call Screen</option>
                  <option value='Leaderboard Screen'>Leaderboard Screen</option>
                  <option value='Home Screen'>Home Screen</option>
                </select>
              </div>
              <div className='col-md-6 mb-7'>
                <label className='form-label fw-bold'>Gender</label>
                <select
                  className='form-select form-select-solid'
                  value={currentRow.gender}
                  onChange={(e) => setCurrentRow({...currentRow, gender: e.target.value})}
                >
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Both'>Both</option>
                </select>
              </div>
            </div>

            <div className='mb-7'>
              <label className='form-label fw-bold'>Countries</label>
              <Select
                isMulti
                options={countries}
                className='basic-multi-select'
                classNamePrefix='select'
                value={countries.filter((c) => currentRow.countries.includes(c.value))}
                onChange={(selected) =>
                  setCurrentRow({...currentRow, countries: selected.map((s: any) => s.value)})
                }
              />
            </div>

            <div className='mb-7'>
              <label className='form-label fw-bold'>Media Content</label>
              <div className='card bg-light border p-5'>
                <div className='mb-5'>
                  <label className='fs-7 fw-bold mb-2 d-block'>1. Upload Video File</label>
                  <input
                    type='file'
                    className='form-control form-control-solid'
                    onChange={(e) => handleFileUpload(e, 'row')}
                    accept='video/*'
                  />
                  <div className='fs-8 text-muted mt-1'>
                    Uploading a file will automatically update the link field below.
                  </div>
                </div>

                <div className='separator separator-dashed mb-5'></div>

                <div>
                  <label className='fs-7 fw-bold mb-2 d-block'>2. Video Link (uploaded or external)</label>
                  <input
                    type='text'
                    className='form-control form-control-solid'
                    placeholder='Enter video URL...'
                    value={currentRow.videoLink || ''}
                    onChange={(e) => setCurrentRow({...currentRow, videoLink: e.target.value})}
                  />
                  {currentRow.videoLink && !currentRow.videoLink.startsWith('http') && (
                    <div className='mt-2'>
                      <span className='text-primary fs-8 fw-bold'>Relative Path Detected: </span>
                      <span className='text-muted fs-8'>{currentRow.videoLink}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {currentRow.videoLink && (
              <div className='mb-7'>
                <label className='form-label fw-bold d-block mb-3'>Preview</label>
                <div className='border rounded p-3 text-center bg-light' style={{maxHeight: '200px', overflow: 'hidden'}}>
                   {renderMediaPreview(currentRow.videoLink, '150px')}
                </div>
              </div>
            )}

            <div className='mb-7'>
              <div className='d-flex align-items-center justify-content-between bg-light p-4 rounded border border-dashed border-gray-300'>
                <div>
                  <label className='form-label fw-bold mb-0'>Rule Status</label>
                  <div className='fs-7 text-muted'>Enable or disable this specific rule</div>
                </div>
                <div className='form-check form-switch'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    role='switch'
                    checked={currentRow.status !== false}
                    onChange={(e) => setCurrentRow({...currentRow, status: e.target.checked})}
                  />
                </div>
              </div>
            </div>

            <div className='mb-1'>
              <div className='d-flex align-items-center justify-content-between bg-light p-4 rounded'>
                <div>
                  <label className='form-label fw-bold mb-0'>Is Skippable</label>
                  <div className='fs-7 text-muted'>Allow users to skip this video</div>
                </div>
                <div className='form-check form-switch'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    role='switch'
                    checked={currentRow.isSkippable || false}
                    onChange={(e) => setCurrentRow({...currentRow, isSkippable: e.target.checked})}
                  />
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant='primary' onClick={saveRow}>
            {editingIndex !== null ? 'Update Rule' : 'Add Rule'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default LeaderboardVideoPlayPlugin
